import ApiService from "./ApiService";

export default class SurveyAnswerService extends ApiService {
    collection = 'survey_answers'

    getAnswerWithSurvey = async (id) => {
        return await this.client.get(`/api/${this.collection}/get_answer_with_survey/${id}`);
    }
}